module.exports = __webpack_public_path__ + "img/img_19@2x.e4d3ffaa.png";